export { default as Img200 } from './processed/200/Dunkirk_.jpg';
export { default as Img400 } from './processed/400/Dunkirk_.jpg';
export { default as Imgthumb } from './processed/thumb/Dunkirk_.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Dunkirk_.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Dunkirk_.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      32,
      180,
      172
    ],
    "_population": 15,
    "_hsl": [
      0.490990990990991,
      0.6981132075471699,
      0.41568627450980394
    ]
  },
  "LightVibrant": {
    "_rgb": [
      156,
      219,
      236
    ],
    "_population": 25,
    "_hsl": [
      0.5354166666666668,
      0.6779661016949153,
      0.7686274509803922
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      39,
      76,
      95
    ],
    "_population": 904,
    "_hsl": [
      0.5565476190476191,
      0.417910447761194,
      0.2627450980392157
    ]
  },
  "Muted": {
    "_rgb": [
      79,
      132,
      153
    ],
    "_population": 2029,
    "_hsl": [
      0.5472972972972973,
      0.3189655172413793,
      0.4549019607843137
    ]
  },
  "LightMuted": {
    "_rgb": [
      164,
      190,
      201
    ],
    "_population": 2737,
    "_hsl": [
      0.5495495495495496,
      0.2551724137931033,
      0.7156862745098039
    ]
  },
  "DarkMuted": {
    "_rgb": [
      58,
      63,
      70
    ],
    "_population": 2178,
    "_hsl": [
      0.5972222222222222,
      0.09375000000000006,
      0.25098039215686274
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Dunkirk_.js